import { Map } from 'immutable';
import { combineReducers } from 'redux';
import Constants from '../../constants/index';
import questions from './questions';
import answers from './answers';
import topics from './topics';
import users from './users';
import spaces from './spaces';

import { VoteRecord, ExpertRecord } from '../../records/index';
import { reducerMerger } from '../helpers/entities';
import { comments } from './comments';

export const DEFAULT_STATE = Map({});

const votes = reducerMerger(
	[Constants.VOTE_UP, Constants.VOTE_DOWN, Constants.FETCH_USER_VOTES],
	'votes',
	VoteRecord,
	DEFAULT_STATE,
);

/*
 Users and experts are associated with one another only when we are interested in representing
 the reputation of a user (reputation data living within expert records).
 */
//  Merges in data regarding CQ experts. Source is CQ Micros.
const expertsByAllTime = reducerMerger(
	Constants.FETCH_EXPERTS_BY_ALL_TIME,
	'experts',
	ExpertRecord,
	DEFAULT_STATE,
);
const expertsByWeek = reducerMerger(
	Constants.FETCH_EXPERTS_BY_WEEK,
	'experts',
	ExpertRecord,
	DEFAULT_STATE,
);
const expertsByTopic = reducerMerger(
	Constants.FETCH_EXPERTS_BY_TOPIC,
	'experts',
	ExpertRecord,
	DEFAULT_STATE,
);
const experts = reducerMerger(Constants.FETCH_EXPERT, 'experts', ExpertRecord, DEFAULT_STATE);

export default combineReducers({
	spaces,
	questions,
	answers,
	topics,
	users,
	expertsByAllTime,
	expertsByWeek,
	expertsByTopic,
	experts,
	votes,
	comments,
});
